import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { type InsurancePremium } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type GetEnrollmentInsurancePremiumsQueryArgs = {
  enrollmentId: string
  memberId: string
}

export function getEnrollmentInsurancePremiumsQueryKey ({
  enrollmentId,
  memberId,
}: GetEnrollmentInsurancePremiumsQueryArgs) {
  return [
    'brokers',
    'members',
    memberId,
    'enrollments',
    enrollmentId,
    'insurance_premiums',
  ]
}

export function useGetEnrollmentInsurancePremiums ({
  enrollmentId,
  memberId,
}: GetEnrollmentInsurancePremiumsQueryArgs) {
  return useQuery<InsurancePremium[], GrapeAPIErrorType>({
    queryKey: getEnrollmentInsurancePremiumsQueryKey({ enrollmentId, memberId }),
    queryFn: async () => {
      const response = await fetchWithHeaders(
        `/api/web/brokers/members/${memberId}/enrollments/${enrollmentId}/insurance_premiums`
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    retry: false,
  })
}
